import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { SUPPORT_EMAIL } from "@/lib/assets";

export default function Terms() {
  return (
    <LegalLayout
      testid="terms-page"
      title="Terms & Conditions"
      updated="June 2026"
    >
      <p>
        Welcome to Waidbook. These Terms &amp; Conditions ("Terms") govern your
        use of the Waidbook mobile application and this website. By downloading,
        accessing, or using Waidbook, you agree to be bound by these Terms.
      </p>

      <LegalSection heading="1. Acceptance of Terms">
        <p>
          By creating an account or using Waidbook, you confirm that you are at
          least 16 years old and that you accept these Terms in full. If you do
          not agree, please do not use the app.
        </p>
      </LegalSection>

      <LegalSection heading="2. Use of the App">
        <p>
          Waidbook is provided as a personal hunting logbook and companion tool.
          You agree to use the app lawfully and responsibly, and to comply with
          all applicable hunting laws, regulations, and licensing requirements
          in your jurisdiction.
        </p>
        <p>
          Waidbook does not grant any hunting rights or permits and is not a
          substitute for official regulations or professional advice.
        </p>
      </LegalSection>

      <LegalSection heading="3. Your Account">
        <p>
          You are responsible for maintaining the confidentiality of your
          account credentials and for all activity that occurs under your
          account. Please notify us immediately of any unauthorized use.
        </p>
      </LegalSection>

      <LegalSection heading="4. Your Content">
        <p>
          You retain ownership of the logs, notes, photos, and data you create
          in Waidbook. You grant us a limited license to store and display this
          content solely for the purpose of providing the service to you.
        </p>
      </LegalSection>

      <LegalSection heading="5. Acceptable Use">
        <p>You agree not to:</p>
        <ul className="list-disc space-y-2 pl-6 marker:text-[#CAA362]">
          <li>Use the app for any unlawful or harmful purpose.</li>
          <li>Attempt to disrupt, reverse-engineer, or compromise the app.</li>
          <li>Upload content that is illegal, offensive, or infringing.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="6. Disclaimer of Warranties">
        <p>
          Waidbook is provided "as is" and "as available" without warranties of
          any kind. We do not guarantee that the app will be uninterrupted,
          error-free, or that map, weather, or location data will always be
          accurate. Always use your own judgment in the field.
        </p>
      </LegalSection>

      <LegalSection heading="7. Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Waidbook shall not be liable
          for any indirect, incidental, or consequential damages arising from
          your use of the app, including any reliance on data provided within
          it.
        </p>
      </LegalSection>

      <LegalSection heading="8. Account Termination">
        <p>
          You may delete your account at any time from within the app — see the{" "}
          <a
            href="/delete-account"
            className="text-[#E0BE82] underline underline-offset-4 hover:text-[#CAA362]"
          >
            Delete Account
          </a>{" "}
          page. We reserve the right to suspend or terminate accounts that
          violate these Terms.
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes to These Terms">
        <p>
          We may update these Terms from time to time. Continued use of Waidbook
          after changes are posted constitutes acceptance of the revised Terms.
        </p>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <p>
          For any questions regarding these Terms, contact us at{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-[#E0BE82] underline underline-offset-4 hover:text-[#CAA362]"
          >
            {SUPPORT_EMAIL}
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
